// Languages are taken from here: https://stackoverflow.com/questions/3217492/list-of-language-codes-in-yaml-or-json
export const LANGUAGES = [
  'Abkhaz',
  'Afar',
  'Afrikaans',
  'Akan',
  'Albanian',
  'Amharic',
  'Arabic',
  'Aragonese',
  'Armenian',
  'Assamese',
  'Avaric',
  'Avestan',
  'Aymara',
  'Azerbaijani',
  'Bambara',
  'Bashkir',
  'Basque',
  'Belarusian',
  'Bangla',
  'Bihari',
  'Bislama',
  'Bosnian',
  'Breton',
  'Bulgarian',
  'Burmese',
  'Catalan',
  'Chamorro',
  'Chechen',
  'Chichewa',
  'Chinese',
  'Chuvash',
  'Cornish',
  'Corsican',
  'Cree',
  'Croatian',
  'Czech',
  'Danish',
  'Divehi',
  'Dutch',
  'English',
  'Esperanto',
  'Estonian',
  'Ewe',
  'Faroese',
  'Fijian',
  'Finnish',
  'French',
  'Fula',
  'Galician',
  'Georgian',
  'German',
  'Greek, Modern',
  'Guaraní',
  'Gujarati',
  'Haitian; Haitian Creole',
  'Hausa',
  'Hebrew (modern)',
  'Herero',
  'Hindi',
  'Hiri Motu',
  'Hungarian',
  'Interlingua',
  'Indonesian',
  'Interlingue',
  'Irish',
  'Igbo',
  'Inupiaq',
  'Ido',
  'Icelandic',
  'Italian',
  'Inuktitut',
  'Japanese',
  'Javanese',
  'Kalaallisut',
  'Kannada',
  'Kanuri',
  'Kashmiri',
  'Kazakh',
  'Khmer',
  'Kikuyu',
  'Kinyarwanda',
  'Kirghiz',
  'Komi',
  'Kongo',
  'Korean',
  'Kurdish',
  'Kwanyama',
  'Latin',
  'Luxembourgish',
  'Luganda',
  'Limburgish',
  'Lingala',
  'Lao',
  'Lithuanian',
  'Luba-Katanga',
  'Latvian',
  'Manx',
  'Macedonian',
  'Malagasy',
  'Malay',
  'Malayalam',
  'Maltese',
  'Māori',
  'Marathi',
  'Marshallese',
  'Mongolian',
  'Nauru',
  'Navajo',
  'Norwegian Bokmål',
  'North Ndebele',
  'Nepali',
  'Ndonga',
  'Norwegian Nynorsk',
  'Norwegian',
  'Nuosu',
  'South Ndebele',
  'Occitan',
  'Ojibwe, Ojibwa',
  'Old Church Slavonic',
  'Oromo',
  'Oriya',
  'Ossetian,',
  'Panjabi,',
  'Pāli',
  'Persian',
  'Polish',
  'Pashto',
  'Portuguese',
  'Quechua',
  'Romansh',
  'Kirundi',
  'Romanian',
  'Russian',
  'Sanskrit',
  'Sardinian',
  'Sindhi',
  'Northern Sami',
  'Samoan',
  'Sango',
  'Serbian',
  'Scottish Gaelic; Gaelic',
  'Shona',
  'Sinhala',
  'Slovak',
  'Slovene',
  'Somali',
  'Southern Sotho',
  'Spanish',
  'Sundanese',
  'Swahili',
  'Swati',
  'Swedish',
  'Tamil',
  'Telugu',
  'Tajik',
  'Thai',
  'Tigrinya',
  'Tibetan',
  'Turkmen',
  'Tagalog',
  'Tswana',
  'Tonga (Tonga Islands)',
  'Turkish',
  'Tsonga',
  'Tatar',
  'Twi',
  'Tahitian',
  'Uighur',
  'Ukrainian',
  'Urdu',
  'Uzbek',
  'Venda',
  'Vietnamese',
  'Volapük',
  'Walloon',
  'Welsh',
  'Wolof',
  'Western Frisian',
  'Xhosa',
  'Yiddish',
  'Yoruba',
  'Zhuang',
];
